import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = async () => {
      // ۱. دریافت توکن‌ها قبل از پاک‌سازی
      const accessToken = localStorage.getItem("app_havir");
      const refreshToken = localStorage.getItem("app_rt");

      // ۲. پاک‌سازی کامل
      localStorage.removeItem("app_havir");
      localStorage.removeItem("app_rt");
      localStorage.removeItem("login_time");

      // ۳. انتشار رویداد برای همگام‌سازی همان تب
      window.dispatchEvent(new Event("auth-change"));

      // ۴. درخواست logout به سرور (اختیاری)
      if (accessToken && refreshToken) {
        try {
          await axios.post(
            `https://rasad-api.havirard.ir/logout?app_havir=${accessToken}&app_rt=${refreshToken}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              timeout: 10000,
            }
          );
          // موفقیت‌آمیز بود اما نیازی به toast نیست چون ریدایرکت می‌کنیم
        } catch (error) {
          // حتی اگر سرور خطا دهد، کاربر باید از سمت کلاینت خارج شود
          console.warn("Logout server request failed", error);
        }
      }

      // ۵. ریدایرکت به صفحه لاگین
      navigate("/login", { replace: true });
    };

    logoutUser();
  }, [navigate]);

  return (
    <ToastContainer
      closeButton={false}
      limit={1}
      rtl={true}
      position="top-center"
      autoClose={3000}
    />
  );
};

export default Logout;